export default __webpack_public_path__ + "static/FranklinGothic-Book-e23195818be042e842bb87e671991448.woff2";